function t(t,n,e){return"function"==typeof t?t(n,e):t}export{t as default};
//# sourceMappingURL=resolveComponentProps.js.map
